import { cn } from "@/lib/chillnn/cn";
import { formatDate } from "@/lib/dayjs/format-date";
import type { BillingStatus } from "@/lib/gql/__generated__/graphql";

import { Button } from "@/components/ui/button/button";

type RecurringTicketInfoProps = {
	billingStatus: BillingStatus;
	canShowNextBillingDtPro: boolean;
	onChangeSettingClick: () => void;
};

export const RecurringTicketInfo = ({
	billingStatus,
	canShowNextBillingDtPro,
	onChangeSettingClick,
}: RecurringTicketInfoProps) => {
	return (
		<>
			<p className="col-span-2">
				{billingStatus.defaultProBillingTicketName || "定期購入中のチケットはありません"}
			</p>
			{canShowNextBillingDtPro && (
				<div className="col-span-1">
					<p className="text-xs">次回のご請求日</p>
					<p>{formatDate(billingStatus.nextBillingDtPro!, "YYYY年MM月DD日")}</p>
				</div>
			)}
			<div className={cn("flex justify-end", canShowNextBillingDtPro ? "col-span-1" : "col-span-2")}>
				<Button type="button" variant="outline" onClick={onChangeSettingClick}>
					変更する
				</Button>
			</div>
		</>
	);
};

RecurringTicketInfo.displayName = "RecurringTicketInfo";
